import React from "react";
import { arrayOf, bool, element, func, string, shape } from "prop-types";
import Button from "pages/_components/Button";
import Dropdown from "pages/_components/Dropdown";

import { ContextMenu as ContextMenuSB } from "@ui-kit/components/index.es";
import * as i18n from "util/i18n";
import * as configUtils from "util/config";
import { getTransferUxI18nKey } from "util/transferInternalTitleLabels";

const getContextMenuItemLabelKey = (label) => {
    if (label === "accounts.actions.transfer.internal") {
        return getTransferUxI18nKey(label);
    }
    return label;
};

export default function ContextMenu({
    isDesktop,
    children,
    items,
    styleContext,
    contributorDropdown,
    imageDropdown,
    dropBtnClass,
    listClassName,
    dropClass,
    additionalClass,
    color,
    newContextMenuClassName,
    disableNewContextMenu = false,
    mobileTitle,
    mobileIconTitle,
    mobileIconTitleColor,
    mobileIconTitleVariant,
    mobileTriggerIcon,
    mobileTriggerIconVariant,
}) {
    ContextMenu.propTypes = {
        isDesktop: bool,
        children: arrayOf(element),
        items: arrayOf(shape({ label: string.isRequired, onClick: func, disabled: bool })),
        styleContext: shape({}),
        contributorDropdown: bool,
        imageDropdown: string,
        dropBtnClass: string,
        listClassName: string,
        dropClass: string,
        additionalClass: string,
        color: string,
        disableNewContextMenu: bool,
        mobileTitle: string,
        mobileIconTitle: string,
        mobileIconTitleColor: string,
        mobileIconTitleVariant: string,
        mobileTriggerIcon: string,
        mobileTriggerIconVariant: string,
        newContextMenuClassName: string,
    };

    ContextMenu.defaultProps = {
        isDesktop: true,
        children: null,
        items: null,
        styleContext: {},
        contributorDropdown: false,
        imageDropdown: null,
        dropBtnClass: "",
        listClassName: null,
        dropClass: "",
        additionalClass: "",
        newContextMenuClassName: "",
        disableNewContextMenu: false,
        mobileTitle: undefined,
        mobileIconTitle: undefined,
        mobileIconTitleColor: undefined,
        mobileIconTitleVariant: undefined,
        mobileTriggerIcon: undefined,
        mobileTriggerIconVariant: undefined,
        color: undefined,
    };

    const newContextMenu = configUtils.getBoolean("frontend.Show.ContextualMenu.Functionalities", false);

    if (newContextMenu && !disableNewContextMenu) {
        return (
            <ContextMenuSB
                color={color}
                className={newContextMenuClassName}
                mobileTitle={mobileTitle}
                mobileIconTitle={mobileIconTitle}
                mobileIconTitleColor={mobileIconTitleColor}
                mobileIconTitleVariant={mobileIconTitleVariant}
                mobileTriggerIcon={mobileTriggerIcon}
                mobileTriggerIconVariant={mobileTriggerIconVariant}
                menuOptions={items.map((item) => ({
                    label: i18n.get(getContextMenuItemLabelKey(item.label)),
                    callback: item.onClick,
                    icon: item.icon || "Info",
                    iconVariant: item.iconVariant || "outline",
                }))}
            />
        );
    }

    return (items && items.length > 0) || children ? (
        <div
            className={`${isDesktop ? "account-list-div" : "context-mobile"}  ${additionalClass || ""}`}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
            style={styleContext}
            onKeyDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
            role="button"
            tabIndex={0}>
            <Dropdown
                image={imageDropdown || "context-menu.svg"}
                bsStyle="link"
                buttonClass={`context-menu-button context-menu-dropdown view-back ${
                    isDesktop ? "account-list-div" : "ml-0"
                } ${contributorDropdown ? "contributor-dropdown" : ""} ${dropBtnClass}`}
                listClassName={listClassName}
                imageStyle="context-menu-svg-img"
                dropClass={dropClass}
                fitWidth>
                {items.map((item) => (
                    <Button
                        label={getContextMenuItemLabelKey(item.label)}
                        onClick={item.onClick}
                        disabled={item.disabled}
                        className="dropdown__item-btn btn-b-none dropdown__item-btn-custom justify-content-start my-0 ml-0 w-100"
                    />
                ))}
                {children}
            </Dropdown>
        </div>
    ) : null;
}
